module.exports = __webpack_public_path__ + "img/web-developer.356df0c1.svg";